import React from "react"
import ReactMarkdown from "react-markdown"
import PropTypes from "prop-types"
import { VALID_ONE_PAGERS } from "../../constants/valid-one-pagers"
const isAbsoluteUrl = require("is-absolute-url")

function recordOutboundClick(href) {
  // @ts-ignore
  if (typeof window.gtag !== `function`) {
    return false
  }

  // @ts-ignore
  window.gtag("event", "click", {
    event_category: "outbound",
    event_label: href,
    transport_type: "beacon",
  })
  return false
}

function isValidOnePageLink(href) {
  if (!/^\/to\//.test(href)) return false
  const name = href.replace("/to/", "")
  return VALID_ONE_PAGERS.includes(name) ? true : false
}

function isRedirectLink(href) {
  return /^\/links\//.test(href)
}

function isAnchorLink(href) {
  return /^#/.test(href)
}

function LinkRenderer(props) {
  const href = props.href
  if (
    !isAbsoluteUrl(href) &&
    !isRedirectLink(href) &&
    !isValidOnePageLink(href) &&
    !isAnchorLink(href)
  ) {
    throw new Error(
      `The link ${href} should be absolute, a redirect, or link to a valid 1-pager`
    )
  }
  return (
    <a
      href={href}
      onClick={event => {
        return recordOutboundClick(href)
      }}
      onContextMenu={event => {
        return recordOutboundClick(href)
      }}
    >
      {props.children}
    </a>
  )
}

const Markdown = props => {
  return (
    <ReactMarkdown children={props.input} components={{ link: LinkRenderer }} />
  )
}

Markdown.propTypes = {
  input: PropTypes.string.isRequired,
}

export default Markdown
